export const PLAN_STATUS_TYPE = strings => ({
  planned: strings.planned,
  harvested: strings.harvested,
  canceled: strings.canceled
})
